import React, { Component } from 'react';
import LoadingSpinner from 'app/components/base/LoadingSpinner';
import { Flex } from 'app/components/base/Layout';
import TripCard from '../commons/TripCard';
import builder from '../commons/builder';

import style from './style.css';


/**
 * Stateless component for using as desktop return trip component.
 * It uses an interface to be used in a `Field` component from `redux-form`.
 *
 * If no trip object is provided, it will show a loading spinner.
 * @return {Component}
 */
export class DesktopReturnTrip extends Component {
  handleBookTrip = () => {
    this.props.bookChangedModeTrip();
  };
  render() {
    const { trip } = this.props;
    return (
      <Flex className={style.container}>
        {trip
          ? <TripCard onClickBook={this.handleBookTrip} trip={trip} />
          : <div className={style.loading}><LoadingSpinner size="small" /></div>
        }
      </Flex>
    );
  }
}

// TODO: move to Flow types
// DesktopReturnTrip.propTypes = {
//   trip: PropTypes.object,
//   bookChangedModeTrip: PropTypes.func.isRequired
// };

export default builder(DesktopReturnTrip);
